import { Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarClickEvent, CalendarTask } from '@infodata-group/inf-commons';
import { CalendarSection } from '../calendar-section';
import dayjs from 'dayjs';

@Component({
  selector: 'infl-task',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './task.component.html',
  styleUrl: './task.component.scss',
})
export class TaskComponent {
  public task = input.required<CalendarTask>();
  public canResize = input(true);
  public section = input<CalendarSection>(null);

  public startResize = output<{
    event: MouseEvent;
    task: CalendarTask;
    direction: 'left' | 'right';
  }>();
  public taskClick = output<CalendarClickEvent>();
  public taskDblClick = output<CalendarClickEvent>();
  public taskHover = output<CalendarTask>();

  public taskStyle = computed(() => {
    return {
      borderColor: this.task().borderColor ?? this.task().backgroundColor,
      color: this.task().color,
    };
  });

  public isResizeAllowed() {
    return this.task().enable && this.canResize();
  }

  public canResizeRight = computed(() => {
    if (!this.isResizeAllowed()) {
      return false;
    }
    if (this.section().nbSection === 1) {
      return false;
    }
    const taskDateStart = dayjs(this.task().dateStart);
    return taskDateStart.isBefore(this.section().startAfternoon);
  });

  public canResizeLeft = computed(() => {
    if (!this.isResizeAllowed()) {
      return false;
    }
    if (this.section().nbSection === 1) {
      return false;
    }
    const taskDateEnd = dayjs(this.task().dateEnd);
    return !taskDateEnd.isBefore(this.section().startAfternoon);
  });

  resize(event: MouseEvent, task: CalendarTask, direction: 'left' | 'right') {
    if (this.canResize()) {
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.preventDefault();
      this.startResize.emit({ event: event, task: task, direction: direction });
    }
  }

  onTaskClick(event: MouseEvent, task: CalendarTask, dblClick: boolean) {
    const calendarEvent = new CalendarClickEvent(event, task);
    dblClick
      ? this.taskDblClick.emit(calendarEvent)
      : this.taskClick.emit(calendarEvent);
  }
}
